/*
  jl-zoom — enlarges a card photo in an overlay.

  The theme's own zoom lives inside its <product-gallery> element and expects
  that component's markup, so it cannot be pointed at a single card image.
  This is the small standalone replacement: one delegated listener for the whole
  page, no dependencies, no per-card script.

  Markup contract, produced by snippets/jl-product-card.liquid:
    <button class="jl-card__zoom" data-jl-zoom data-zoom-src="..." data-zoom-alt="...">
*/

(function () {
  'use strict';

  var overlay = null;
  var image = null;
  var lastFocused = null;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'jl-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.hidden = true;

    image = document.createElement('img');
    image.className = 'jl-zoom__img';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'jl-zoom__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
      '</svg>';

    overlay.appendChild(image);
    overlay.appendChild(close);
    document.body.appendChild(overlay);

    close.addEventListener('click', hide);
    // A click on the backdrop closes; a click on the photo itself does not
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) hide();
    });
  }

  function show(button) {
    if (!overlay) build();

    lastFocused = button;
    image.src = button.getAttribute('data-zoom-src');
    image.alt = button.getAttribute('data-zoom-alt') || '';
    overlay.hidden = false;
    // Locking the body keeps the page behind from scrolling under the overlay
    document.body.classList.add('jl-zoom-open');
    overlay.querySelector('.jl-zoom__close').focus();
  }

  function hide() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    image.removeAttribute('src');
    document.body.classList.remove('jl-zoom-open');
    if (lastFocused) lastFocused.focus();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-jl-zoom]');
    if (!button) return;
    event.preventDefault();
    show(button);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') hide();
  });
})();
